import React from 'react';
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button } from "reactstrap";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ApprovalRequisition from './ApprovalRequisition';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ApprovalRequisitionHistory from '../salesHead/ApprovalRequisitonHistory';
import { useDispatch } from 'react-redux';
import { StorePageHeaderName } from '../../store/pageHeader/action';
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const RequisitionTabs = () => {

  const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Approval Requisition'));

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },]

  return (
    <div className="page-content">
    <Container fluid>
    <Box sx={{ width: '100%' }}>
      <Box sx={{backgroundColor:"white" }}>
        <Tabs value={value} onChange={handleChange}>
          {/* <Tab label="View and Edit"  {...a11yProps(0)} />
          <Tab label="Approval Pending"  {...a11yProps(1)} /> */}
             <Tab label="Approval Requisition" sx={{ textTransform: "none", fontSize:"16px" , color:'#2B2A29' }} {...a11yProps(0)} />
             <Tab label="Approval Requisition History" sx={{ textTransform: "none", fontSize:"16px" , color:'#2B2A29' }} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel className="tabs_padding" value={value} index={0}>
        <ApprovalRequisition />
      </CustomTabPanel>
      <CustomTabPanel className="tabs_padding" value={value} index={1}>
        <ApprovalRequisitionHistory />
      </CustomTabPanel>
    </Box>
    </Container>
    </div>
    // <>
    //   <div>
    //     <div class="tab tab_content">
    //       <button class="tablinks" onclick="openCity(event, 'London')" id="defaultOpen">LOGIN</button>
    //       <button class="tablinks" onclick="openCity(event, 'Paris')">SIGN UP</button>
    //     </div>

    //     <div id="London" class="tabcontent">
    //       <div>
    //         <div class="input_field">
    //           <div class="input-with-icon">
    //             <input type="text" placeholder="Email">
    //               <span class="icon_position">
    //                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                   <rect width="24" height="24" rx="4" fill="white" />
    //                   <path d="M7.5 6.5C7.5 8.981 9.519 11 12 11C14.481 11 16.5 8.981 16.5 6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5ZM20 21H21V20C21 16.141 17.859 13 14 13H10C6.14 13 3 16.141 3 20V21H20Z" fill="#296CED" />
    //                 </svg>
    //               </span>
    //             </input>
    //           </div>
    //           <div class="input-with-icon password_field">
    //             <input type="password" placeholder="Passowrd" class="passowrd_type_box">
    //               <span class="icon_position">
    //                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                   <g clip-path="url(#clip0_4_2325)">
    //                     <path d="M20 12C20 10.897 19.103 10 18 10H17V7C17 4.243 14.757 2 12 2C9.243 2 7 4.243 7 7V10H6C4.897 10 4 10.897 4 12V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V12ZM9 7C9 5.346 10.346 4 12 4C13.654 4 15 5.346 15 7V10H9V7Z" fill="#296CED" />
    //                   </g>
    //                   <defs>
    //                     <clipPath id="clip0_4_2325">
    //                       <rect width="24" height="24" rx="4" fill="white" />
    //                     </clipPath>
    //                   </defs>
    //                 </svg>
    //               </span>
    //             </input>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div id="Paris" class="tabcontent">
    //     <div>
    //       <div class="input_field">
    //         <div class="input-with-icon">
    //           <input type="text" placeholder="Startup Name">
    //             <span class="icon_position">
    //               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <rect width="24" height="24" rx="4" fill="white" />
    //                 <path d="M7.5 6.5C7.5 8.981 9.519 11 12 11C14.481 11 16.5 8.981 16.5 6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5ZM20 21H21V20C21 16.141 17.859 13 14 13H10C6.14 13 3 16.141 3 20V21H20Z" fill="#296CED" />
    //               </svg>
    //             </span>
    //           </input>
    //         </div>
    //         <div class="input-with-icon password_field">
    //           <input type="text" placeholder="Phone">
    //             <span class="icon_position">
    //               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <path d="M16.5559 12.906L16.1009 13.359C16.1009 13.359 15.0179 14.435 12.0629 11.497C9.10788 8.559 10.1909 7.483 10.1909 7.483L10.4769 7.197C11.1839 6.495 11.2509 5.367 10.6339 4.543L9.37388 2.86C8.60988 1.84 7.13488 1.705 6.25988 2.575L4.68988 4.135C4.25688 4.567 3.96688 5.125 4.00188 5.745C4.09188 7.332 4.80988 10.745 8.81388 14.727C13.0609 18.949 17.0459 19.117 18.6749 18.965C19.1909 18.917 19.6389 18.655 19.9999 18.295L21.4199 16.883C22.3799 15.93 22.1099 14.295 20.8819 13.628L18.9719 12.589C18.1659 12.152 17.1859 12.28 16.5559 12.906Z" fill="#296CED" />
    //               </svg>
    //             </span>
    //           </input>
    //         </div>
    //         <div class="input-with-icon password_field">
    //           <input type="text" placeholder="Email">
    //             <span class="icon_position">
    //               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#296CED" />
    //               </svg>
    //             </span>
    //           </input>
    //         </div>
    //         <div class="input-with-icon password_field">
    //           <input type="text" placeholder="Pssword">
    //             <span class="icon_position">
    //               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <g clip-path="url(#clip0_4_2325)">
    //                   <path d="M20 12C20 10.897 19.103 10 18 10H17V7C17 4.243 14.757 2 12 2C9.243 2 7 4.243 7 7V10H6C4.897 10 4 10.897 4 12V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V12ZM9 7C9 5.346 10.346 4 12 4C13.654 4 15 5.346 15 7V10H9V7Z" fill="#296CED" />
    //                 </g>
    //                 <defs>
    //                   <clipPath id="clip0_4_2325">
    //                     <rect width="24" height="24" rx="4" fill="white" />
    //                   </clipPath>
    //                 </defs>
    //               </svg>
    //             </span>
    //           </input>
    //         </div>
    //         <div class="input-with-icon password_field">
    //           <input type="text" placeholder="Re-type Password">
    //             <span class="icon_position">
    //               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <g clip-path="url(#clip0_4_2325)">
    //                   <path d="M20 12C20 10.897 19.103 10 18 10H17V7C17 4.243 14.757 2 12 2C9.243 2 7 4.243 7 7V10H6C4.897 10 4 10.897 4 12V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V12ZM9 7C9 5.346 10.346 4 12 4C13.654 4 15 5.346 15 7V10H9V7Z" fill="#296CED" />
    //                 </g>
    //                 <defs>
    //                   <clipPath id="clip0_4_2325">
    //                     <rect width="24" height="24" rx="4" fill="white" />
    //                   </clipPath>
    //                 </defs>
    //               </svg>
    //             </span>
    //           </input>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </>
  );
}
export default RequisitionTabs;